import {Injectable} from '@angular/core';
import {combineLatest, Observable, of} from 'rxjs';
import {Client, Culture, Office, Role, Timezone} from '..';
import {Country} from '../models/country';
import {BillingProduct, Product} from '../models/product';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import * as fromShared from '../../shared/reducers';
import * as fromSite from '../../site/reducers';
import * as fromOrders from '../../order/reducers';
import * as fromContract from '../../contract/reducers';
import {Device} from '../models/device';
import {ServerForm} from '../models/servers';
import {SimpleObject} from '../models/simple-object';
import {catchError, map, skipWhile} from 'rxjs/operators';
import {Site} from '../models/site';
import {SelectedPlayers} from '../../site/models/player-filter';
import {Player} from '../models/player';
import * as _ from 'lodash';
import { Order } from '../../order/models/order';
import {Concept} from '../models/concept';
import {Contract} from '../../contract/models/contract';
import {ContractItem} from '../../contract/models/contract-item';
import {ianaTimezones} from '../../../assets/files/iana-timezones';


@Injectable({
  providedIn: 'root'
})
export class DataSelectService {
  site$: Observable<Site>;
  selectedPlayers$: Observable<SelectedPlayers[]>;
  players$: Observable<Player[]>;
  contract$: Observable<ContractItem[]>;
  currentContract$: Observable<Contract>;
  billingProduct$: Observable<BillingProduct[]>;
  product$: Observable<Product[]>;
  selectedPlayersDeviceID: string;
  private roles$: Observable<Role[]>;
  order$: Observable<Order>;
  orderArray$: Observable<Order[]>;


  constructor(private store: Store<fromRoot.AppState>, private storeOrder: Store<fromOrders.AppState>) {
    this.site$ = this.store.pipe(select(fromSite.selectors.getSite));
    this.roles$ = this.store.pipe(select(fromShared.selectors.getMyRoles));
    this.selectedPlayers$ = this.store.pipe(select(fromSite.selectors.getPlayersSelected));
    this.orderArray$ = this.storeOrder.pipe(select(fromOrders.selectors.getOrdersSelected));
    this.order$ = this.storeOrder.pipe(select(fromOrders.selectors.getOrder));
    this.players$ = this.store.pipe(select(fromSite.selectors.getPlayers));
    this.contract$ = this.store.pipe(select(fromContract.selectors.getContracts));
    this.currentContract$ = this.store.pipe(select(fromContract.selectors.getCurrentContract));
    this.billingProduct$ = this.store.pipe(select(fromShared.selectors.getBillingProducts));
    this.product$ = this.store.pipe(select(fromShared.selectors.getProducts));
    this.selectedPlayers$.subscribe((selectedPlayer => {
      if (selectedPlayer && selectedPlayer[0]) {
        this.selectedPlayersDeviceID = selectedPlayer[0].deviceID;
      }
    }));
  }

  isInRole$(role: string): Observable<boolean> {
    return this.roles$.pipe(map(roles => _.findIndex(roles, ['code', role]) > -1));
  }

  getDataSelect(dataName: string):
    Observable<Timezone[]
      | Culture[]
      | Office[]
      | Client[]
      | Country[]
      | Product[]
      | Concept[]
      | Device[]
      // tslint:disable-next-line:no-any
      | object[]
      | ServerForm[]
      | SimpleObject[]
      | string[]
      | number[]> {
    if (dataName.toLowerCase() === 'timezone'.toLowerCase() || dataName.toLowerCase() === 'time.timeZone'.toLowerCase()) {
       return of(ianaTimezones);
     // return this.store.pipe(select(fromRoot.selectors.getTimezones));
    } else if (dataName.toLowerCase() === 'cultures'.toLowerCase()) {
      return this.store.pipe(select(fromRoot.selectors.getCultures));
    } else if (dataName.toLowerCase() === 'country'.toLowerCase()) {
      return this.store.pipe(select(fromRoot.selectors.getCountries));
    } else if (dataName.toLowerCase() === 'product'.toLowerCase()) {
      return this.store.pipe(select(fromRoot.selectors.getProducts));
    }
    else if (dataName.toLowerCase() === 'productCodeDHL'.toLowerCase()) {
        return this.store.pipe(select(fromOrders.selectors.getRating));
    }

   else if (dataName.toLowerCase() === 'status'.toLowerCase()) {
      return of([{ id: 2, name: 'Pilot' }, { id: 3, name: 'Exploit' }]);
    } else if (dataName.toLowerCase() === 'statusAll'.toLowerCase()) {
      return this.players$.pipe(
        skipWhile((data) => !data),
        map((players: Player[]) => {
          let result = null;
          this.isInRole$('BO_CANCLOSESITE').pipe(
            map((isInRole) => {
                if (!isInRole) {
                  this.site$.subscribe(data => {
                    if (data) {
                      if (!players.length) {
                        result = [
                          { id: 3, name: 'Exploit' },
                          { id: 2, name: 'Pilot' },
                          { id: 0, name: 'To off - no update' },
                          { id: -1, name: 'Stopped' },
                          { id: -2, name: 'Bankruptcy' }
                        ]
                      } else {
                        if (data.subscriptions[0].status === 1) {
                          result = [
                            { id: 3, name: 'Exploit' },
                            { id: 2, name: 'Pilot' },
                            { id: 1, name: 'Off' },
                            { id: 0, name: 'To off - no update' },
                            { id: -1, name: 'Stopped' },
                            { id: -2, name: 'Bankruptcy' }
                          ]
                        } else {
                          result = [
                            { id: 3, name: 'Exploit' },
                            { id: 2, name: 'Pilot' },
                            { id: 0, name: 'To off - no update' },
                            { id: -1, name: 'Stopped' },
                            { id: -2, name: 'Bankruptcy' }
                          ]
                        }

                      }
                    }
                  });
                } else {
                  this.site$.subscribe(data => {
                    if (data) {
                      if (!players.length) {
                        result = [
                          { id: 3, name: 'Exploit' },
                          { id: 2, name: 'Pilot' },
                          { id: 1, name: 'Off' },
                          { id: 0, name: 'To off - no update' },
                          { id: -1, name: 'Stopped' },
                          { id: -2, name: 'Bankruptcy' }
                        ]
                      } else {
                        if (data.subscriptions[0].status === 1) {
                          result = [
                            { id: 3, name: 'Exploit' },
                            { id: 2, name: 'Pilot' },
                            { id: 1, name: 'Off' },
                            { id: 0, name: 'To off - no update' },
                            { id: -1, name: 'Stopped' },
                            { id: -2, name: 'Bankruptcy' }
                          ]
                        } else {
                          result = [
                            { id: 3, name: 'Exploit' },
                            { id: 2, name: 'Pilot' },
                            { id: 0, name: 'To off - no update' },
                            { id: -1, name: 'Stopped' },
                            { id: -2, name: 'Bankruptcy' }
                          ]
                        }

                      }
                    }
                  });
                }
              }
            )).subscribe();

          return result;
        })
      )
    } else if (dataName.toLowerCase() === 'addresstype'.toLowerCase()) {
      const orderList = [];
      this.orderArray$.subscribe(orders => {
        if (orders) {

        let index = 1;
        for (let j = 0; j < orders.length; j++) {

              orderList.push({ id: index, name: orders[j].site.name + ' : address ' + orders[j].addresses[0].addressType});
              if (orders[j].addresses.length > 1)     {
              index++;
              orderList.push({ id: index, name: orders[j].site.name + ' : address ' + orders[j].addresses[1].addressType });

            }
              index++;
          }

        }

        });
      this.order$.subscribe(order => {
        if (order && orderList.length === 0) {
            orderList.push({ id: 1, name: order.site.name + ' : address ' + order.addresses[0].addressType });
            if (order.addresses.length > 1) {
              orderList.push({ id: 2, name: order.site.name + order.addresses[1].addressType });
            }
        }
      });
      return of(orderList);
    }

    else if (dataName.toLowerCase() === 'allplayerids'.toLowerCase()) {
      const orderList = [];
      this.order$.subscribe(order => {
        if (order && orderList.length === 0) {
        for (let index = 0; index < order.subscription.players.length; index++) {
          orderList.push({ id: index, name: order.subscription.players[index].deviceID});
        }

        }
      });
      return of(orderList);
    }
    else if (dataName.toLowerCase() === 'statusFilter'.toLowerCase()) {
      return of([
        { id: 3, name: 'Exploit' },
        { id: 2, name: 'Pilot' },
        { id: 1, name: 'Off' },
        { id: 0, name: 'To off - no update' },
        { id: -1, name: 'Stopped' },
        { id: -2, name: 'Bankruptcy' }
      ]);
    } else if (dataName.toLowerCase() === 'services'.toLowerCase()) {
      return of([{ id: 1, name: 'Audio' }, { id: 2, name: 'Video' }]);
    } else if (dataName.toLowerCase() === 'servicesAllChoice'.toLowerCase()) {
      return of([
        { id: 1, name: 'Audio' },
        { id: 2, name: 'Video' },
        { id: 3, name: 'Audio + Video' },
      ]);
    } else if (dataName.toLowerCase() === 'Licences'.toLowerCase()) {
      // return of([
      //   { id: 1, name: 'CommercialMusic' },
      //   { id: 2, name: 'Jamendo' },
      //   { id: 3, name: 'SoundReef' },
      //   { id: 4, name: 'Other collecting societies' },
      // ]);
      return this.store.pipe(select(fromShared.selectors.getLicences));
    } else if (dataName.toLowerCase() === 'device'.toLowerCase()) {
      return this.store.pipe(select(fromShared.selectors.getDeviceAvailable));
    } else if (dataName.toLowerCase() === 'support'.toLowerCase()) {
      // return of([
      //   { id: 41, name: 'Anastasios Vracas' },
      //   { id: 34, name: 'Binwu Dio' },
      //   { id: 74, name: 'Carsten Klenke' },
      //   { id: 61, name: 'Cindy Despontin' },
      //   { id: 44, name: 'David mutamba' },
      //   { id: 68, name: 'Fabrice Visart' },
      //   { id: 45, name: 'François Lefort' },
      //   { id: 67, name: 'Jens Van Goethem ' },
      //   { id: 73, name: 'Mariya Vyalykh' },
      //   { id: 65, name: 'Pierre Steenackers' },
      //   { id: 37, name: 'Sylvia Ferreiro' },
      //   { id: 49, name: 'Thorsten Mende' }
      // ]);
      return this.store.pipe(select(fromShared.selectors.getSupportUsers));
    } else if (dataName.toLowerCase() === 'orderstatus'.toLowerCase()) {
      return of([
        { id: 0, name: 'NEW' },
        { id: 1, name: 'HAS_PLAYER' },
        { id: 2, name: 'SET_UP' },
        { id: 3, name: 'TEST_COMPLETED' },
        { id: 4, name: 'PACKED' },
        { id: 5, name: 'SHIP' },
        { id: 6, name: 'DELIVERED' },
        { id: 7, name: 'CLOSED' },
      ]);
    } else if (dataName.toLowerCase() === 'analyticCode'.toLowerCase()) {
      return of([
        { id: 0, name: 'MMBOX' },
        { id: 1, name: 'MMSAV' },
        { id: 2, name: 'MAT' },
        { id: 3, name: 'CD-SD' },
      ]);
    } else if (dataName.toLowerCase() === 'sales'.toLowerCase()) {
      return this.store.pipe(select(fromShared.selectors.getUsersByType, 'Sales'));
    } else if (dataName.toLowerCase() === 'office'.toLowerCase()) {
      // return of([
      //   { id: 1, name: 'OFFICE_BE' },
      //   { id: 2, name: 'OFFICE_FR' },
      //   { id: 3, name: 'OFFICE_ES' },
      //   { id: 4, name: 'OFFICE_DE' },
      //   { id: 5, name: 'OFFICE_CN' },
      // ]);
      return this.store.pipe(select(fromShared.selectors.getOffices));
    } else if (dataName.toLowerCase() === 'split'.toLowerCase()) {
      return of([
        { id: 1, name: 'PO' },
        { id: 2, name: 'Site' },
        { id: 3, name: 'Country' },
        { id: 4, name: 'Contract' },
        { id: 5, name: 'Client' },
        { id: 6, name: 'Company' },
      ]);
    } else if (dataName.toLowerCase() === 'recurrence'.toLowerCase()) {
      return of([
        {id: 1, name: 'Monthly'},
        {id: 3, name: 'Quarterly'},
        {id: 6, name: 'Biannual'},
        {id: 12, name: 'Yearly'},
        {id: 24, name: '2 Years'},
        {id: 36, name: '3 Years'},
        {id: 48, name: '4 Years'},
        {id: 60, name: '5 Years'},
        {id: 72, name: '6 Years'},
        {id: 84, name: '7 Years'},
        {id: 96, name: '8 Years'},
        {id: 108, name: '9 Years'},
        {id: 120, name: '10 Years'},
        // { id: 0, name: 'Anniversary' },

      ]);
    }
    else if (dataName.toLowerCase() === 'recurrenceInvoices'.toLowerCase()) {
        return of([
          { id: 'Monthly', name: 'Monthly' },
          { id: 'Quaterly', name: 'Quarterly' },
          { id: 'Biannual', name: 'Biannual' },
          { id: 'Yearly', name: 'Yearly' },
          { id: 'Yearly2', name: '2 Years' },
          { id: 'Yearly3', name: '3 Years' },
          { id: 'Yearly4', name: '4 Years' },
          { id: 'Yearly5', name: '5 Years' },
          { id: 'Yearly6', name: '6 Years' },
          { id: 'Yearly7', name: '7 Years' },
          { id: 'Yearly8', name: '8 Years' },
          { id: 'Yearly9', name: '9 Years' },
          { id: 'Yearly10', name: '10 Years' },
          // { id: 0, name: 'Anniversary' },

        ]);

    } else if (dataName.toLowerCase() === 'recurrenceInvoicesShort'.toLowerCase()) {

      return   this.contract$.pipe(
        skipWhile((data) => !data),
        map((contracts: ContractItem[]) => {
      const contractList = [];
      let uniqueArray = [];
      for (let j = 0; j < contracts.length; j++) {
        if (contracts[j].recurrence === 1) {
          contractList.push({ id: 'Monthly', name: 'Monthly' });
        }
        if (contracts[j].recurrence === 3) {
          contractList.push({ id: 'Quaterly', name: 'Quarterly' });
        }
        if (contracts[j].recurrence === 6) {
          contractList.push({ id: 'Biannual', name: 'Biannual' });
        }
        if (contracts[j].recurrence === 12) {
          contractList.push({ id: 'Yearly', name: 'Yearly' });
        }
        if (contracts[j].recurrence === 24) {
          contractList.push({ id: 'Yearly2', name: '2 Years' });
        }
        if (contracts[j].recurrence === 36) {
          contractList.push({ id: 'Yearly3', name: '3 Years' });
        }
        if (contracts[j].recurrence === 48) {
          contractList.push({ id: 'Yearly4', name: '4 Years' });
        }
        if (contracts[j].recurrence === 60) {
          contractList.push({ id: 'Yearly5', name: '5 Years' });
        }
        if (contracts[j].recurrence === 72) {
          contractList.push({ id: 'Yearly6', name: '6 Years' });
        }
        if (contracts[j].recurrence === 84) {
          contractList.push({ id: 'Yearly7', name: '7 Years' });
        }
        if (contracts[j].recurrence === 96) {
          contractList.push({ id: 'Yearly8', name: '8 Years' });
        }
        if (contracts[j].recurrence === 108) {
          contractList.push({ id: 'Yearly9', name: '9 Years' });
        }
        if (contracts[j].recurrence === 120) {
          contractList.push({ id: 'Yearly10', name: '10 Years' });
        }
       }

      uniqueArray =  contractList.filter((item, index, self) =>
            index === self.findIndex((t) => t.id === item.id)
          );
      return uniqueArray;
      })
      );
      }
    else if (dataName.toLowerCase() === 'sla'.toLowerCase()) {
      return of([
        { id: 1, name: 'Exchange with installation' },
        { id: 2, name: 'Exchange' },
      ]);
    } else if (dataName.toLowerCase() === 'typeOfShipping'.toLowerCase()) {
      return of([
        {id: 1, name: 'TYPE_OF_SHIPPING_RETURN'},
        {id: 2, name: 'TYPE_OF_SHIPPING_DEPLOY'},
        {id: 4, name: 'TYPE_OF_SHIPPING_EXCHANGE'},
        {id: 5, name: 'TYPE_OF_SHIPPING_EXTRA'},
        {id: 6, name: 'TYPE_OF_SHIPPING_TO_PTL'},
        {id: 7, name: 'TYPE_OF_SHIPPING_COLLECT_RETURN'},
        {id: 8, name: 'TYPE_OF_SHIPPING_UPDATE_CD'},
      ]);
    } else if (dataName.toLowerCase() === 'bnsProductList'.toLowerCase()) {
        return of([
          { id: 'ls', name: 'LS' },
          { id: 'hd', name: 'HD' },
          { id: 'xd', name: 'XD' },
          { id: 'xt', name: 'XT' },
          { id: 'xc', name: 'XC' },
          { id: 'au', name: 'AU' },
          { id: 'hs', name: 'HS ' },
        ]);
    } else if (dataName.toLowerCase() === 'transporters'.toLowerCase()) {
      return this.store.pipe(select(fromShared.selectors.getTransporters));
    } else if (dataName.toLowerCase() === 'servers'.toLowerCase()) {
      return this.store.pipe(select(fromShared.selectors.getServer));
    } else if (dataName.toLowerCase() === 'cms'.toLowerCase()) {
      return this.store.pipe(select(fromShared.selectors.getCMS));
    } else if (dataName.toLowerCase() === 'serversUrl'.toLowerCase()) {
      return this.store.pipe(select(fromShared.selectors.getServerUrl));
    } else if (dataName.toLowerCase() === 'typeOrder'.toLowerCase()) {
      return of([{ id: 2, name: 'Deploy' }, { id: 4, name: 'Exchange' }]);
    } else if (dataName.toLowerCase() === 'security_type'.toLowerCase()) {
      return of([
        { id: 'NONE', name: 'ORDER_FORM_WIFI_SECURITY_NONE' }, { id: 'WEP', name: 'ORDER_FORM_WIFI_SECURITY_WEP' },
        { id: 'WPA2', name: 'ORDER_FORM_WIFI_SECURITY_WPA2' }, { id: 'WPA2AES', name: 'ORDER_FORM_WIFI_SECURITY_WPA2AES' },
        { id: '802', name: 'ORDER_FORM_WIFI_SECURITY_802EAP' }]);
    } else if (dataName.toLowerCase() === 'eap_methodName'.toLowerCase()) {
      return of([
        { id: 'PEAP', name: 'ORDER_FORM_WIFI_EAP_METHOD_PEAP' }, { id: 'TLS', name: 'ORDER_FORM_WIFI_EAP_METHOD_TLS' },
        { id: 'TTLS', name: 'ORDER_FORM_WIFI_EAP_METHOD_TTLS' }, { id: 'PWD', name: 'ORDER_FORM_WIFI_EAP_METHOD_PWD' }]);
    } else if (dataName.toLowerCase() === 'eap_phase_2_authentication'.toLowerCase()) {
      return of([
        { id: 'NONE', name: 'ORDER_FORM_WIFI_PHASE_2_AUTH_NONE' }, { id: 'PAP', name: 'ORDER_FORM_WIFI_PHASE_2_AUTH_PAP' },
        { id: 'MSCHAP', name: 'ORDER_FORM_WIFI_PHASE_2_AUTH_MSCHAP' }, { id: 'MSCHAPV2', name: 'ORDER_FORM_WIFI_PHASE_2_AUTH_MSCHAPV2' },
        { id: 'GTC', name: 'ORDER_FORM_WIFI_PHASE_2_AUTH_GTC' }]);
    } else if (dataName.toLowerCase() === 'screenRotation'.toLowerCase() || dataName.toLowerCase() === 'hardware.videoOut.0.rotation'.toLowerCase()) {
      return of([
        { id: 0, name: 'Landscape (0°)' },
        { id: 90, name: 'Portait (90°)' },
        { id: 180, name: 'Reverse Landscape (180°)' },
        { id: 270, name: 'Reverse Portrait (270°)' }
      ]);
    } else if (dataName.toLowerCase() === 'isDefaultList'.toLowerCase()) {
      return of([{ id: 'true', name: 'true' }, { id: 'false', name: 'false' }]);
    } else if (dataName.toLowerCase() === 'deviceModel'.toLowerCase()) {
      return this.store.pipe(select(fromSite.selectors.getDeviceModels));
    } else if (dataName.toLowerCase() === 'licences'.toLowerCase()) {
      return this.store.pipe(select(fromSite.selectors.getLicences));
    } else if (dataName.toLowerCase() === 'programs'.toLowerCase()) {
      return this.store.pipe(select(fromSite.selectors.getPrograms));
    } else if (dataName.toLowerCase() === 'productsByService'.toLowerCase()) {
      return this.store.pipe(select(fromSite.selectors.getProductsByService));
    } else if (dataName.toLowerCase() === 'productsBySite'.toLowerCase()) {
      return this.store.pipe(select(fromSite.selectors.getProductsBySite));
    } else if (dataName.toLowerCase() === 'products'.toLowerCase()) {
      return this.store.pipe(select(fromSite.selectors.getProducts));
    } else if (dataName.toLowerCase() === 'servicesList'.toLowerCase()) {
      return this.store.pipe(select(fromShared.selectors.getServices));
    } else if (dataName.toLowerCase() === 'productsCompleteList'.toLowerCase()) {
      return this.store.pipe(select(fromShared.selectors.getProductsCompleteList));
    } else if (dataName.toLowerCase() === 'clients'.toLowerCase()) {
      return this.store.pipe(select(fromShared.selectors.getMyClients));
    } else if (dataName.toLowerCase() === 'concepts'.toLowerCase()) {
      return this.store.pipe(select(fromShared.selectors.getConcepts));
    }
    else if (dataName.toLowerCase() === 'sites'.toLowerCase()) {
      return this.store.pipe(select(fromShared.selectors.getMySites));
    } else if (dataName.toLowerCase() === 'companyList'.toLowerCase()) {
      return this.store.pipe(select(fromShared.selectors.getCompaniesLinkContract));
    } else if (dataName.toLowerCase() === 'contractList'.toLowerCase()) {
      return this.store.pipe(select(fromShared.selectors.getContractLink));
    } else if (dataName.toLowerCase() === 'subscriptionList'.toLowerCase()) {
      return this.store.pipe(select(fromShared.selectors.getSubscriptionsLinkContract));
    } else if (dataName.toLowerCase() === 'productionLine'.toLowerCase()) {
      return this.store.pipe(select(fromShared.selectors.getProductionLine));
    } else if (dataName.toLowerCase() === 'currenciesList'.toLowerCase()) {
      return this.store.pipe(select(fromContract.selectors.getCurrencies));
    } else if (dataName.toLowerCase() === 'families'.toLowerCase()) {
      return this.store.pipe(select(fromOrders.selectors.getFamilies));
    } else if (dataName.toLowerCase() === 'billingproduct'.toLowerCase()) {
       return combineLatest([
        this.currentContract$,
        this.product$,
        this.billingProduct$
      ]).pipe(
        map(([currentContract, products, billingProducts]) => {
          if (!currentContract) {
            return [];
          }

          let serviceType;
          const matchingProduct = products.find(product => currentContract.productID === product.id);
          if (matchingProduct) {
            if (matchingProduct.service.name === 'Video') {
              serviceType = 2
            }
            else if (matchingProduct.service.name === 'Audio') {
              serviceType = 1
            }
            else if (matchingProduct.service.name === 'Service') {
              serviceType = 3
            }
            else if (matchingProduct.service.name === 'Maintenance') {
              serviceType = 4
            }
            else if (matchingProduct.service.name === 'Hosting') {
              serviceType = 5
            }

          }

          return billingProducts
            .filter(billingProduct => billingProduct.code === 'LOC' && serviceType === billingProduct.service)
            .map(billingProduct => ({
              id: billingProduct.id,
              name: `${billingProduct.name} ( ${billingProduct.sapCode} )`,
            }));
        }),
        catchError(error => {
          console.error('Error fetching billing product list:', error);
          return of([]); // Return an empty list in case of error
        })
      );
    }
   else if (dataName.toLowerCase() === 'players'.toLowerCase()) {
      const playerList = [];
      this.players$.subscribe((players => {
          for (let j = 0; j < players.length; j++) {
            if (players[j].deviceID !== this.selectedPlayersDeviceID) {
              playerList.push(players[j]);
            }
          }
        })
      );
      return of(playerList);
    } else if (dataName.toLowerCase() === 'time.autoUpdate.protocol'.toLowerCase()) {
      return of([
        { id: 'content', name: 'content' },
        { id: 'rdate', name: 'rdate' },
        { id: 'http', name: 'http' }
      ]);
    }
    else if (dataName.toLowerCase() === 'companieslanguage'.toLowerCase()) {
      return of([
        { id: 1, name: 'English' },
        { id: 19, name: 'Dutch' },
        { id: 26, name: 'French' },
        { id: 30, name: 'German' },
        { id: 71, name: 'Spanish' },
      ]);
    }
    else if (dataName.toLowerCase() === 'boxtype'.toLowerCase()) {
    return of([
      { id: 1, name: 'ORDER_LIST_SHIPPING_IDENTIFIER_BOX2' },
      { id: 2, name: 'ORDER_LIST_SHIPPING_IDENTIFIER_BOX4' },
      { id: 3, name: 'ORDER_LIST_SHIPPING_IDENTIFIER_LETTER' },
      { id: 4, name: 'ORDER_LIST_SHIPPING_IDENTIFIER_TUBE' },
      { id: 5, name: 'ORDER_LIST_SHIPPING_IDENTIFIER_BOX_AUDIO' },
      { id: 6, name: 'ORDER_LIST_SHIPPING_IDENTIFIER_BOX_VIDEO' },
      { id: 7, name: 'ORDER_LIST_SHIPPING_IDENTIFIER_BOX8_PTL' },
      { id: 8, name: 'ORDER_LIST_SHIPPING_IDENTIFIER_BOX_CD' },
      { id: 9, name: 'ORDER_LIST_SHIPPING_IDENTIFIER_LISA_COMPACT' },
      { id: 10, name: 'ORDER_LIST_SHIPPING_IDENTIFIER_MMBOX' },
      { id: 11, name: 'ORDER_LIST_SHIPPING_IDENTIFIER_STREAMIT' },
      { id: 12, name: 'ORDER_LIST_SHIPPING_IDENTIFIER_CUSTOM' }


    ]);
    }


    else if (dataName.toLowerCase() === 'incoterm'.toLowerCase()) {
      return of([
        { id: 1, name: 'ORDER_LIST_SHIPPING_IDENTIFIER_BOX2' },
        { id: 2, name: 'ORDER_LIST_SHIPPING_IDENTIFIER_BOX4' }]);
      }
    else if (dataName.toLowerCase() === 'transporter'.toLowerCase()) {
      return of([
        { id: 1, name: 'DHL' },
        ]);
      }
    else if (dataName.toLowerCase() === 'TriggerStart'.toLowerCase()) {
      return of([{ id: 3, name: 'Manually' }])
      // { id: 1, name: 'OnDelivery' }, { id: 2, name: 'LicenseActivation' }
    } else if (dataName.toLowerCase() === 'currency'.toLowerCase()) {
      return of([
        { id: 1, name: 'Brazilian real (IDR)' },
        { id: 2, name: 'United States dollar (USD)' },
        { id: 3, name: 'Indian rupee (INR)' },
        { id: 4, name: 'Azerbaijani manat (AZN)' },
        { id: 5, name: 'Russian ruble (RUB)' },
        { id: 6, name: 'Belarusian ruble,Ethiopian bir (BYN)' },
        { id: 7, name: 'Bulgarian lev (BGN)' },
        { id: 8, name: 'Nigerian naira (NGN)' },
        { id: 9, name: 'Bangladeshi taka (BDT)' },
        { id: 10, name: 'Chinese yuan,Japanese yen (JPY)' },
        { id: 11, name: 'Euro (EUR)' },
        { id: 12, name: 'Bosnia and Herzegovina convertible mark (BAM)' },
        { id: 13, name: 'Czech koruna (CZK)' },
        { id: 14, name: 'British pound (GBP)' },
        { id: 15, name: 'Bhutanese ngultrum (BTN)' },
        { id: 16, name: 'Malaysian ringgit (MYR)' },
        { id: 17, name: 'Philippine peso (PHP)' },
        { id: 18, name: 'Bolivian boliviano,Venezuelan bolívar soberano (BOB)' },
        { id: 19, name: 'Costa Rican colón (CRC)' },
        { id: 20, name: 'Guatemalan quetzal (GTQ)' },
      ]);
    } else if (dataName.toLowerCase() === 'deliveryTransferModes'.toLowerCase()) {
      return of([
        { id: 0, name: 'None' },
        { id: 1, name: 'Online' },
        { id: 2, name: 'Offline' },
        { id: 3, name: 'CD' },
        { id: 4, name: 'SD' },
        { id: 5, name: 'USB' },
        { id: 6, name: 'Stream' }
      ]);
    } else if (dataName.toLowerCase() === 'publicationTypes'.toLowerCase()) {
      return of([
        { id: 'Publication_Video', name: 'Vidéo' },
        { id: 'Publication_Audio', name: 'Audio' },
        { id: 'Publication_Audio_Commercial', name: 'Audio commercial' }
      ]);
    } else if (dataName.toLowerCase() === 'PublicationStatus'.toLowerCase()) {
      return of([
        { id: -1, name: 'Failed' },
        { id: 1, name: 'Success' }
      ]);
    } else if (dataName.toLowerCase() === 'PeriodType'.toLowerCase()) {
      return of([
        { id: 1, name: 'INVOICES_TRIGGER_RECURRENCE_Q1' },
        { id: 5, name: 'INVOICES_TRIGGER_RECURRENCE_A2' },
        { id: 6, name: 'INVOICES_TRIGGER_RECURRENCE_A3' },
        { id: 2, name: 'INVOICES_TRIGGER_RECURRENCE_Q2' },
        { id: 7, name: 'INVOICES_TRIGGER_RECURRENCE_A5' },
        { id: 8, name: 'INVOICES_TRIGGER_RECURRENCE_A6' },
        { id: 3, name: 'INVOICES_TRIGGER_RECURRENCE_Q3' },
        { id: 9, name: 'INVOICES_TRIGGER_RECURRENCE_A8' },
        { id: 10, name: 'INVOICES_TRIGGER_RECURRENCE_A9' },
        { id: 4, name: 'INVOICES_TRIGGER_RECURRENCE_Q4' },
        { id: 11, name: 'INVOICES_TRIGGER_RECURRENCE_A11' },
        { id: 12, name: 'INVOICES_TRIGGER_RECURRENCE_A12' }]
      );

    } else if (dataName.toLowerCase() === 'invoicesHistoryStatus'.toLowerCase()) {
      return of([
        { id: 'Created', name: 'Created' },
        { id: 'Started', name: 'Started' },
        { id: 'Failed', name: 'Failed' },
        { id: 'Completed', name: 'Completed' }]);
    } else if (dataName.toLowerCase() === 'invoicesHistoryAdjustment'.toLowerCase()) {
      return of([
        { id: 1, name: 'INVOICES_HISTORY_ADJUSTMENT_ANNUAL' },
        { id: 2, name: 'INVOICES_HISTORY_ADJUSTMENT_BI' }]);
    } else if (dataName.toLowerCase() === 'companyBlocked'.toLowerCase()) {
      return of([
        { id: true, name: 'ONLY_BLOCKED' },
        { id: false, name: 'ONLY_NON_BLOCKED' },
      ]);
    } else if (dataName.toLowerCase() === 'companyActive'.toLowerCase()) {
      return of([
        { id: true, name: 'ONLY_ACTIVE' },
        { id: false, name: 'ONLY_NON_ACTIVE' },
      ]);
    } else if (dataName.toLowerCase() === 'invoicesYears'.toLowerCase()) {
      const year = new Date().getFullYear();
      return of([
        { id: 1, name: '' + (year - 1) + '' },
        { id: 2, name: '' + (year)  + ''  },
        { id: 3, name: '' + (year + 1) + ''  },
        { id: 4, name: '' + (year + 2) + ''  },
      ]);
    } else if (dataName.toLowerCase() === 'month'.toLowerCase()) {
      return of([
        { id: 1, name: '01_MONTH' },
        { id: 2, name: '02_MONTH' },
        { id: 3, name: '03_MONTH' },
        { id: 4, name: '04_MONTH' },
        { id: 5, name: '05_MONTH' },
        { id: 6, name: '06_MONTH' },
        { id: 7, name: '07_MONTH' },
        { id: 8, name: '08_MONTH' },
        { id: 9, name: '09_MONTH' },
        { id: 10, name: '10_MONTH' },
        { id: 11, name: '11_MONTH' },
        { id: 12, name: '12_MONTH' },
      ]);
    }
  }
}
